import React, { useState, useEffect, useRef} from 'react';
import ActionButtonCard from '../Button/ActionButtonCard';
import Swal from 'sweetalert2'
import { Form, Button, Card, InputGroup, FormControl } from 'react-bootstrap';
import { useProvider, Toast } from '../../context/MenuProvider';


const SelecionarCategoria = ({categoriaId, setCategoriaId, tipo, defaultText, label, adicionalText, adicionalValue, multiplos}) => {
  const [categorias, setCategorias] = useState([]);
  
  const { 
    salvarDados,
    buscarDados,
    buscarDadosPorId,
    excluirDadosPorId,
    crud,
    hasPerms,
  } = useProvider();
  const { get, post } = crud || {};
  
  const addCategoria = async(e) => {
      if(e) e.preventDefault();
      const nome_da_categoria = prompt(`Novo(a) ${label || 'Categoria:'}`);
      if (!nome_da_categoria) return;
      try{
        const dataForm ={
          tipo,
          nome_da_categoria,
          categoria_pai:``
        }
        const response = await post(dataForm, `/gvendas/categorias/`, null, 'nova-categoria');
          if(response && response.length){
            setCategorias((prev)=>([
              ...response,
              ...prev
          ]));
          await salvarDados("db_categorias", response);
        }
      }catch(err){
        alert(JSON.stringify(err.response.data || err.response))
      }
  }
  
  // função que processa a string (não sobrescreve `tipo`)
  const processTipo = (input) => {
    if (!input) return ""; // se vazio, retorna string vazia
  
    // garante array de itens sem espaços vazios
    let itens = (typeof input === "string" ? input : input.join(","))
      .split(",")
      .map(s => s.trim())
      .filter(Boolean);
  
    if (itens.includes("produtos") && !hasPerms(["loja.view_produtos"])) {
      itens = itens.filter(i => i !== "produtos");
    }
    if (itens.includes("pessoais") && !hasPerms(["financas.view_financeiro"])) {
      itens = itens.filter(i => i !== "pessoais");
    }
    if (itens.includes("negocio") && !hasPerms(["financas.view_financeiro"])) {
      itens = itens.filter(i => i !== "negocio");
    }
    if (itens.includes("rede") && !hasPerms(["rede.view_apn"])) {
      itens = itens.filter(i => i !== "rede");
    }
  
    return itens.join(",");
  };
  
  //Removento tipos sem permissão
  tipo = processTipo(tipo);
  
  
  const isConsultaCarregada = useRef(false);
  const buscarCategoriasLocal = async () => {
    try{
        const response = await buscarDados(
          "db_categorias", 
          (item) => {
            if (!item?.tipo || !tipo) return false; // garante que não dê erro se algo for null/undefined
            const tipos = tipo.split(',').map(t => t.trim()); // remove espaços extras
            return tipos.some(t => item.tipo.includes(t));
          },
          500,
          'nome_da_categoria'
        );
        if (isConsultaCarregada.current) return;
        if(response && response.length){
          setCategorias(response);
        }
    }catch(err){
      
    }finally{
      
    }
  }
  
  const buscarCategorias = async () => {
    try{
      if (!tipo){
        setCategorias([]);
        return;
      }
      const response = await get(`/gvendas/categorias/?expand=categoria_pai&ordering=nome_da_categoria&tipo__in=${tipo}&limit=500`, 'SelecionarCategoria');
      //alert(JSON.stringify(response))
      if (response && response.length){
        isConsultaCarregada.current = true;
        const lista = response[0].results;
        setCategorias(lista);
        // if (setCategoriaId && !lista.find(item => item.id === categoriaId)) {
        //   setCategoriaId(null);
        // }
        //Buscar categorias locais para remover,salvar e atualizar
        const itens = await buscarDados(
          "db_categorias", 
          (item) => {
            if (!item?.tipo || !tipo) return false; // garante que não dê erro se algo for null/undefined
            const tipos = tipo.split(',').map(t => t.trim()); // remove espaços extras
            return tipos.some(t => item.tipo.includes(t));
          },
          500
        );
        const itens_deletar = itens.filter(item => !lista.includes(item.id));
        if(itens_deletar?.length>0){
          await excluirDadosPorId("db_categorias", itens_deletar);
        }
        await salvarDados("db_categorias", lista);
      }
    }catch(err){

    }finally{
      
    }
  };
  

  useEffect(() => {
    if(tipo) {
      buscarCategoriasLocal();
      buscarCategorias();
    } 
  }, [tipo]);
  
  
  const categoriasAgrupadas = categorias?.reduce((acc, item) => {
    const data = item.tipo_text;
    if (!acc[data]) {
      acc[data] = [];
    }
    acc[data].push(item);
    return acc;
  }, {});
  
  const renderCategorias = (categorias, todas, nivel = 0) => {
    return categorias.map(cat => {
      const filhos = todas.filter(c => c.categoria_pai?.id === cat.id);
  
      return (
        <React.Fragment key={cat.id}>
          {/* prefixo para indicar nível */}
          <option value={cat.id}>
            {`${'— '.repeat(nivel)}${cat.nome}`}
          </option>
  
          {/* chama recursivamente para os filhos */}
          {renderCategorias(filhos, todas, nivel + 1)}
        </React.Fragment>
      );
    });
  };


  return (
    <>
      <div id="formCategoria" className="mt-3">
        <div className="input-group">
          <span className="input-group-text">{label || 'Categoria'}</span>
          <Form.Control
            as="select"
            value={categoriaId}
            multiple={multiplos}
            onChange={(e) => {
              if (multiplos) {
                const values = Array.from(e.target.selectedOptions, opt => opt.value);
                setCategoriaId(values);
              } else {
                setCategoriaId(e.target.value);
              }
            }}
          >
            {!multiplos && (
              <option value="">{defaultText}</option>
            )}
            
            {Object.entries(categoriasAgrupadas).length > 1 ? (
              Object.entries(categoriasAgrupadas).map(([item, itens], index) => (
                <optgroup label={item}>
                  {/* só começa pelos que não têm pai */}
                  {renderCategorias(itens?.filter(c => !c.categoria_pai), categorias)}
                </optgroup>
              ))
            ):(<>
              {/* só começa pelos que não têm pai */}
              {renderCategorias(categorias?.filter(c => !c.categoria_pai), categorias)}
            </>)}
          
          
            {adicionalText && (
              <option value={adicionalValue}>
                {adicionalText || 'Categoria Adicional'}
              </option>
            )}
          </Form.Control>
          {(tipo??'').split(',').map(t => t.trim())?.length ===1 && (
              <Button variant="secondary" onClick={addCategoria}>Nova</Button>
          )}
        </div>
      </div>
    </>
  );
}

export default SelecionarCategoria;
